/** @module ProductSpec/BOMAssortmentMatrixByProduct */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/matrix/Path",
	"csi/xml"
], function(declare, _, Path, xml) {

	return declare(Path, {
		hideLoneSubheader: true,
		restrictQuery: true,

		/**
		 * @override
		 * Return results of view's columnStore
		 */
		_getColumnNodes: function(ctx, h) {
			return ctx.view.columnStore.query();
		},

		/**
		 * @override
		 * Return selected color for row and column
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			var urlBomColor = ctx.getNodeURL();
			var pm = ctx.cache.getNode(spec.columnUrl);
			var pmcs = ctx.cache.getNodes(pm.PartMaterialColors);
			var pmc = _.findWhere(pmcs, {PMCBOMColor: urlBomColor});
			return [pmc];
		}
	});
});